import React from 'react';
import './Pages.css';

function Support() {
  return (
    <div className="page-container">
      <h1 className="page-title">技术支持</h1>
      <p className="subtitle">Technical Support</p>

      <div className="content-card">
        <h2>📧 联系我们</h2>
        <p>如果您在使用六边形贪吃蛇时遇到任何问题，或有任何建议和反馈，欢迎通过以下方式联系我们：</p>
        <div className="contact-info">
          <p><strong>邮箱</strong>: wsmslgh@gmail.com</p>
          <p><strong>反馈时间</strong>: 工作日 9:00-18:00 (GMT+8)</p>
          <p><strong>响应时间</strong>: 通常在24小时内回复</p>
        </div>
      </div>

      <div className="content-card">
        <h2>❓ 常见问题</h2>
        
        <div className="faq-item">
          <h3>Q: 游戏需要联网吗？</h3>
          <p>A: 不需要。六边形贪吃蛇是一款完全离线的单机游戏，您可以随时随地畅玩，不消耗流量。</p>
        </div>

        <div className="faq-item">
          <h3>Q: 游戏支持竖屏吗？</h3>
          <p>A: 游戏专为横屏游戏体验优化设计，只支持横屏模式，以提供最佳的游戏视野和操作体验。</p>
        </div>

        <div className="faq-item">
          <h3>Q: 如何使用加速功能？</h3>
          <p>A: 按住屏幕左侧控制区域中央的"加速"按钮，蛇的移动速度会提升3倍。松开按钮即恢复正常速度。</p>
        </div>

        <div className="faq-item">
          <h3>Q: 最高分记录会丢失吗？</h3>
          <p>A: 不会。您的最高分记录会自动保存在设备本地，卸载应用后会清除，但日常使用中不会丢失。</p>
        </div>

        <div className="faq-item">
          <h3>Q: 游戏有广告吗？</h3>
          <p>A: 完全没有。六边形贪吃蛇是一款纯粹的游戏，无广告、无内购，让您专注享受游戏乐趣。</p>
        </div>

        <div className="faq-item">
          <h3>Q: 支持哪些设备？</h3>
          <p>A: 游戏支持运行iOS 15.0及以上系统的所有iPhone设备，完美适配各种屏幕尺寸。</p>
        </div>

        <div className="faq-item">
          <h3>Q: 游戏耗电严重吗？</h3>
          <p>A: 不会。游戏经过优化，功耗极低，您可以长时间游玩而不必担心电量问题。</p>
        </div>

        <div className="faq-item">
          <h3>Q: 如何重新开始游戏？</h3>
          <p>A: 当游戏结束后，点击屏幕（控制区域除外）任意位置即可重新开始新的一局。</p>
        </div>
      </div>

      <div className="content-card">
        <h2>🐛 问题反馈</h2>
        <p>如果您发现了bug或有改进建议，请发送邮件至 <strong>wsmslgh@gmail.com</strong>，并包含以下信息：</p>
        <ul>
          <li>您的设备型号（例如：iPhone 15 Pro Max）</li>
          <li>iOS系统版本</li>
          <li>问题的详细描述</li>
          <li>问题发生的步骤（如果可以重现）</li>
          <li>截图或录屏（如果有的话）</li>
        </ul>
        <p>您的反馈对我们非常重要，帮助我们不断改进游戏体验！</p>
      </div>

      <div className="content-card">
        <h2>⭐ 评分与评论</h2>
        <p>如果您喜欢六边形贪吃蛇，欢迎在App Store给我们5星好评！您的支持是我们持续优化的动力。</p>
      </div>

      <div className="content-card">
        <h2>🔄 版本更新</h2>
        <p>我们会定期更新游戏，修复问题并添加新功能。请确保您的App Store设置为自动更新，或定期检查更新。</p>
      </div>
    </div>
  );
}

export default Support;
